import { render, staticRenderFns } from "./Approved.vue?vue&type=template&id=172beede&scoped=true&"
import script from "./Approved.vue?vue&type=script&lang=js&"
export * from "./Approved.vue?vue&type=script&lang=js&"
import style0 from "./Approved.vue?vue&type=style&index=0&id=172beede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172beede",
  null
  
)

export default component.exports